import {useHistory} from 'react-router-dom';
import React, {useEffect, useLayoutEffect, useState} from "react";

import {Spinner} from "@chakra-ui/react";
import styled from "styled-components";
import {useAllCommunities, useCommunities, useCommunitySubscribe} from '../../api/communities';
import {useBottomBar} from "../../app_context";
import {useQuery} from '../../utils/router';
import useFeedback from '../../utils/use_feedback';
import useAtBottom from "../../utils/use_at_bottom";
import {FixedTopBar} from "../../components/top_bar";
import Main from '../../components/main';
import ErrorMessage from "../../components/error_message";
import Community from '../../components/community';
import {useLoggedIn, useStoreProfile} from "../../store";
import {themecolors} from "../../utils/themecolors";
import CommunitiesToggles from "../../components/communities_toggles";

const SpinnerContainer = styled.div``;

const CommunitiesPage = styled(({className}) => {
    const {sort} = useQuery();
    const loggedIn = useLoggedIn();
    const activeTopic = useQuery().topic || (loggedIn ? 'subscribed' : 'recommended');
    const history = useHistory();
    const {error, feedbackCh} = useFeedback();

    const [pinnedCommunities, setPinnedCommunities] = useState(null);
    const { communities, loading, loadMore } = useAllCommunities(feedbackCh, 'activity', activeTopic, true );
    const {subscribed, theme, moderates} = useStoreProfile();
    const subscribedCommunities = useCommunities(loading.channel, subscribed);
    const moderatedCommunities = useCommunities(loading.channel, moderates);
    const getSortedCommunities = (communities) => communities.sort((a, b) => (a.name > b.name) ? 1 : -1);

    const communityList =
        activeTopic.toLowerCase() === 'subscribed'
            ? getSortedCommunities(subscribedCommunities)
            : activeTopic.toLowerCase() === 'moderator'
            ? getSortedCommunities(moderatedCommunities)
            : communities;

    const subscribe = useCommunitySubscribe(feedbackCh);
    useEffect(() => {
        setPinnedCommunities(null);
    }, [sort]);
    useBottomBar();
    // Scroll to top when the 'sort' changes.
    useLayoutEffect(() => {
        document.scrollingElement.scrollTop = 0;
    }, [sort]);

    const detector = useAtBottom(loadMore);

    return (
        <>
            <FixedTopBar title={"Communities"} search sidebar settings />
            <Main className={className}>
                <CommunitiesToggles activeTopic={activeTopic} />
                <ErrorMessage error={error}/>
                {communityList?.map((community) =>
                    community && community.visibility !== 'unlisted' && (
                        <Community
                            key={community.name}
                            community={community}
                            condensed
                            subscribe
                            onClick={() => history.push(`/c/${community.name}`)}
                            onSubscribe={async (name) => {
                                if (sort === 'subscribed' && !pinnedCommunities) {
                                    setPinnedCommunities(communities.map((c) => c.name));
                                }
                                await subscribe([name.name]);
                            }}
                        />
                    )
                )}
                {detector}
                {loading &&
                    <SpinnerContainer style={{margin: '48px 0 96px 0', textAlign: 'center'}}>
                            <Spinner
                                thickness='4px'
                                speed='0.65s'
                                emptyColor={theme === "dark" ? themecolors.dark_background_5 : themecolors.light_low_impact_text}
                                color={theme === "dark" ? themecolors.dark_background_2 : themecolors.pure_white}
                                size='lg'
                            />
                    </SpinnerContainer>
                }
            </Main>
        </>
    );
})`
  padding-bottom: 64px;
`;

export default CommunitiesPage;
